import { render, staticRenderFns } from "./ImageClip.vue?vue&type=template&id=90a885d4"
import script from "./ImageClip.vue?vue&type=script&lang=js"
export * from "./ImageClip.vue?vue&type=script&lang=js"
import style0 from "./ImageClip.vue?vue&type=style&index=0&id=90a885d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports